(function() {
  // Remove "Product title" placeholder text embedded in article content
  var container = document.querySelector('.blog-post-content');
  if (container) {
    container.querySelectorAll('p').forEach(function(p) {
      if (p.textContent.trim() === 'Product title') {
        p.remove();
      }
    });
  }

  // Remove featured products section from blog posts
  var productList = document.querySelector('.ui-test-product-list');
  if (productList) productList.remove();

  // Populate recommended articles from same blog
  var path = window.location.pathname;
  var parts = path.split('/');
  var blogIdx = parts.indexOf('blogs');
  if (blogIdx === -1 || blogIdx + 1 >= parts.length) return;
  var blogHandle = parts[blogIdx + 1];
  if (!parts[blogIdx + 2]) return; // not on an article page
  var currentUrl = path;

  var section = document.querySelector('.penguin-recommended-blogs');
  if (!section) return;
  var inner = section.querySelector('.penguin-recommended-blogs__inner');
  if (!inner) return;

  fetch('/blogs/' + blogHandle)
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      // Find article title links
      var titleLinks = doc.querySelectorAll('a[data-testid="blog-post-link"]');
      var seen = {};
      var articles = [];

      titleLinks.forEach(function(link) {
        var href = link.getAttribute('href');
        if (!href || href === currentUrl || seen[href]) return;
        var title = link.textContent.trim();
        if (!title || title.length < 3) return;
        seen[href] = true;

        // Find image by matching href in image container links
        var img = null;
        var imgLink = doc.querySelector('.blog-post-card__image-container a[href="' + href + '"] img');
        if (imgLink) {
          img = imgLink.getAttribute('src');
          if (!img) {
            var srcset = imgLink.getAttribute('srcset');
            if (srcset) img = srcset.split(',').pop().trim().split(' ')[0];
          }
        }
        if (img && img.startsWith('//')) img = 'https:' + img;
        articles.push({ href: href, title: title, img: img });
      });

      // Fallback: try any links to blog articles
      if (articles.length === 0) {
        var allLinks = doc.querySelectorAll('a[href*="/blogs/' + blogHandle + '/"]');
        allLinks.forEach(function(link) {
          var href = link.getAttribute('href');
          if (!href || href === currentUrl || seen[href]) return;
          var title = link.textContent.trim();
          if (!title || title.length < 5 || title.length > 150 || title === 'Read more...') return;
          seen[href] = true;
          articles.push({ href: href, title: title, img: null });
        });
      }

      if (articles.length === 0) return;
      articles = articles.slice(0, 4);

      var grid = document.createElement('div');
      grid.className = 'penguin-recommended-blogs__grid';
      grid.style.cssText = 'display:grid;grid-template-columns:repeat(4,1fr);column-gap:16px;row-gap:24px;margin-top:2rem;';

      // Add responsive styles
      var style = document.createElement('style');
      style.textContent = '@media(max-width:1024px){.penguin-recommended-blogs__grid{grid-template-columns:repeat(2,1fr)!important;}}@media(max-width:640px){.penguin-recommended-blogs__grid{grid-template-columns:1fr!important;}}';
      document.head.appendChild(style);

      articles.forEach(function(a) {
        var item = document.createElement('div');
        item.className = 'penguin-recommended-blogs__item';
        item.style.textAlign = 'center';
        var imgHtml = '';
        if (a.img) {
          imgHtml = '<a href="' + a.href + '" style="display:block;"><div style="position:relative;width:100%;aspect-ratio:3/2;overflow:hidden;border-radius:8px;"><img src="' + a.img + '" alt="' + a.title.replace(/"/g, '&quot;') + '" style="width:100%;height:100%;object-fit:cover;display:block;" loading="lazy"></div></a>';
        }
        item.innerHTML = imgHtml + '<h3 style="margin-top:0.8rem;font-size:18px;line-height:1.4;"><a href="' + a.href + '" style="color:inherit;text-decoration:none;">' + a.title + '</a></h3>';
        grid.appendChild(item);
      });

      // Remove "No articles available" text
      var noArticles = inner.querySelector('p');
      if (noArticles) noArticles.remove();
      inner.appendChild(grid);
    })
    .catch(function(e) { console.error('Recommended articles error:', e); });
})();
